import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'antd';
import { FormattedMessage } from 'react-intl';
import { getIsVisibleModal, closeModal } from '../redux/store/ui/common';
import packageInfo from '../../package.json';
import styles from './LicensesModal.styles';

export const LICENSES_MODAL = 'licensesModal';

const LicensesModal: React.FC = () => {
  const dispatch = useDispatch();
  const visible = useSelector(getIsVisibleModal(LICENSES_MODAL));

  return (
    <>
      <Modal
        wrapClassName="licenses-wrapper"
        title={`© GETAWAY・v${packageInfo.version}`}
        open={visible}
        width={345}
        style={{ top: 'calc(25%)' }}
        onCancel={() => dispatch(closeModal(LICENSES_MODAL))}
        footer={null}
      >
        <a
          href="/imprint.html"
          target="_blank"
          rel="noopener noreferrer"
          className="modal-item"
        >
          <FormattedMessage id="fleetadmin.modal.licenses" />
        </a>
      </Modal>
      <style jsx global>
        {styles}
      </style>
    </>
  );
};

export default LicensesModal;
